/* Modded Moto Co - "Choose Your Bike" launcher + bike picker modal.
 * Desktop: a pill in the header. Mobile: a full-width bar row under the header
 * (so the centered logo never covers it). Opens a modal of bike platforms, each
 * linking to that platform's collection. Self-contained (styles + data inline).
 */
(function () {
  'use strict';
  if (window.__mmcBikePicker) return;
  window.__mmcBikePicker = true;

  var BIKES = [
    { b: 'SUR-RON',    m: 'Light Bee',    h: 'light-bee',          n: '400-450' },
    { b: 'SUR-RON',    m: 'Ultra Bee',    h: 'ultrabee',           n: '250-300' },
    { b: 'E-RIDE PRO', m: 'E-Ride Pro',   h: 'eride-pro-1',        n: '250-300' },
    { b: 'TALARIA',    m: 'XXX',          h: 'xxx',                n: '150-200' },
    { b: 'TALARIA',    m: 'Sting MX',     h: 'mx',                 n: '200-250' },
    { b: 'TUTTIO',     m: 'Soleil 01',    h: 'tuttio-1',           n: '50-100' },
    { b: 'YOZMA',      m: 'IN 10',        h: 'yozma-1',            n: '' },
    { b: 'SEGWAY',     m: 'X160 / X260',  h: 'segway-parts',       n: '50-100' },
    { b: 'RAWRR',      m: 'Mantis',       h: 'rawrr-mantis-parts', n: '' },
    { b: 'SUPER73',    m: 'Super73',      h: 'super73',            n: '' },
    { b: 'STARK',      m: 'Varg',         h: 'stark-varg',         n: '' },
    { b: '79BIKE',     m: 'Falcon',       h: 'falcon-79',          n: '150-200' },
    { b: 'ALTIS',      m: 'Sigma',        h: 'altis-sigma',        n: '50-100' },
    { b: 'VENTUS',     m: 'One',          h: 'ventus-one',         n: '150-200' },
    { b: '',           m: 'Macfox',       h: 'macfox-parts',       n: '' },
    { b: '',           m: 'MotoTec',      h: 'mototec-parts',      n: '' },
    { b: '',           m: 'HeyBike',      h: 'heybike-parts',      n: '' }
  ];

  var BIKE_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="5.5" cy="17.5" r="3.5"></circle><circle cx="18.5" cy="17.5" r="3.5"></circle><path d="M15 6a1 1 0 100-2 1 1 0 000 2zm-3.5 11.5L9 9h5l2 4h2.5M9 9l-2 3"></path></svg>';

  function injectStyles() {
    if (document.getElementById('mmc-ride-style')) return;
    var css =
      '.mmc-ride-launch{display:inline-flex;align-items:center;gap:8px;padding:9px 16px;margin-left:8px;border:2px solid #bd40c7;border-radius:999px;background:transparent;color:inherit;font-size:12px;font-weight:800;letter-spacing:.05em;text-transform:uppercase;cursor:pointer;white-space:nowrap;transition:background .15s;line-height:1;}' +
      '.mmc-ride-launch:hover{background:rgba(189,64,199,.12);}' +
      '.mmc-ride-launch svg{flex:0 0 auto;color:#bd40c7;}' +
      '.mmc-ride-bar{grid-column:1/-1;display:flex;align-items:center;justify-content:center;gap:9px;margin:9px 0 1px;padding:12px;border:2px solid #bd40c7;border-radius:12px;background:transparent;color:inherit;font-size:14px;font-weight:800;letter-spacing:.05em;text-transform:uppercase;cursor:pointer;width:100%;line-height:1;}' +
      '.mmc-ride-bar:hover{background:rgba(189,64,199,.12);}' +
      '.mmc-ride-bar svg{flex:0 0 auto;color:#bd40c7;}' +
      '.mmc-ride-overlay{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;background:rgba(10,9,11,.72);backdrop-filter:blur(4px);padding:16px;}' +
      '.mmc-ride-overlay.mmc-open{display:flex;}' +
      '.mmc-ride-modal{width:min(760px,100%);max-height:88vh;overflow:auto;background:#161416;border:1px solid rgba(255,255,255,.1);border-radius:18px;box-shadow:0 24px 70px rgba(0,0,0,.55);}' +
      '.mmc-ride-head{position:sticky;top:0;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:20px 22px;background:linear-gradient(180deg,#1d1a1e,#161416);border-bottom:1px solid rgba(255,255,255,.08);}' +
      '.mmc-ride-head h2{margin:0;font-size:19px;font-weight:800;color:#fff;letter-spacing:-.01em;}' +
      '.mmc-ride-head p{margin:3px 0 0;font-size:13px;color:#b7b1bd;}' +
      '.mmc-ride-close{flex:0 0 auto;width:36px;height:36px;border-radius:50%;border:1px solid rgba(255,255,255,.16);background:transparent;color:#fff;font-size:20px;line-height:1;cursor:pointer;transition:background .15s;}' +
      '.mmc-ride-close:hover{background:rgba(255,255,255,.1);}' +
      '.mmc-ride-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;padding:20px 22px 24px;}' +
      '@media (max-width:749px){.mmc-ride-grid{grid-template-columns:repeat(2,1fr);gap:10px;padding:16px;}}' +
      '.mmc-ride-card{display:flex;flex-direction:column;gap:2px;padding:14px 15px;border:1px solid rgba(255,255,255,.1);border-radius:12px;background:rgba(255,255,255,.03);text-decoration:none;transition:border-color .15s,background .15s,transform .1s;}' +
      '.mmc-ride-card:hover{border-color:#bd40c7;background:rgba(189,64,199,.1);transform:translateY(-2px);}' +
      '.mmc-ride-brand{font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#e79bef;}' +
      '.mmc-ride-model{font-size:16px;font-weight:800;color:#fff;line-height:1.15;}' +
      '.mmc-ride-count{font-size:12px;color:#8f8a95;margin-top:3px;}' +
      '.mmc-ride-foot{padding:0 22px 22px;}' +
      '.mmc-ride-all{display:block;text-align:center;padding:13px;border-radius:11px;background:transparent;border:2px solid #bd40c7;color:#fff;font-weight:800;font-size:14px;text-decoration:none;text-transform:uppercase;letter-spacing:.04em;transition:background .15s;}' +
      '.mmc-ride-all:hover{background:rgba(189,64,199,.16);}';
    var s = document.createElement('style');
    s.id = 'mmc-ride-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  var overlay;
  function buildModal() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'mmc-ride-overlay';
    var cards = BIKES.map(function (bk) {
      return '<a class="mmc-ride-card" href="/collections/' + bk.h + '">' +
        '<span class="mmc-ride-brand">' + bk.b + '</span>' +
        '<span class="mmc-ride-model">' + bk.m + '</span>' +
        (bk.n ? '<span class="mmc-ride-count">' + bk.n + ' products</span>' : '') +
      '</a>';
    }).join('');
    overlay.innerHTML =
      '<div class="mmc-ride-modal" role="dialog" aria-modal="true" aria-label="Choose your bike">' +
        '<div class="mmc-ride-head">' +
          '<div><h2>What do you ride?</h2><p>Jump straight to parts that fit your bike.</p></div>' +
          '<button type="button" class="mmc-ride-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="mmc-ride-grid">' + cards + '</div>' +
        '<div class="mmc-ride-foot"><a class="mmc-ride-all" href="/collections">View all bikes</a></div>' +
      '</div>';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.mmc-ride-close')) close();
    });
    document.body.appendChild(overlay);
    return overlay;
  }
  function open() { buildModal().classList.add('mmc-open'); document.documentElement.style.overflow = 'hidden'; }
  function close() { if (overlay) overlay.classList.remove('mmc-open'); document.documentElement.style.overflow = ''; }

  function makeBtn(cls) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = cls;
    btn.setAttribute('aria-label', 'Choose your bike');
    btn.innerHTML = BIKE_SVG + '<span class="mmc-ride-txt">Choose Your Bike</span>';
    btn.addEventListener('click', open);
    return btn;
  }

  function placeLauncher() {
    // Desktop header: pill in the left cluster (auto-hidden on mobile since #header-inner is display:none there).
    var parts = document.querySelectorAll('.\\#header-part');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p.querySelector('.mmc-ride-launch')) continue;
      var tb = p.querySelector('.\\#header-toolbar');
      if (tb && (tb.className || '').indexOf('@left') !== -1) p.appendChild(makeBtn('mmc-ride-launch'));
    }
    // Mobile header: full-width bar row (auto-hidden on desktop since #header-inner-mobile is display:none there).
    var inners = document.querySelectorAll('.\\#header-inner-mobile');
    for (var j = 0; j < inners.length; j++) {
      if (inners[j].querySelector('.mmc-ride-bar')) continue;
      inners[j].appendChild(makeBtn('mmc-ride-bar'));
    }
  }

  function init() {
    injectStyles();
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var tries = 0;
    (function attempt() {
      placeLauncher();
      if (tries++ > 12) return;      // idempotent; keeps retrying so both header variants get covered
      setTimeout(attempt, 300);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
